import React from 'react'
import { AdvancedFilter } from 'components/Filter/AdvancedFilter'
import { ResidualValueDetail } from './ResidualValueDetail/ResidualValueDetail'
import { ResidualValueForm } from './ResidualValueForm/ResidualValueForm'
import { ResidualValueMain } from './ResidualValueMain'

const residualValueRoutes = [
  /* -------------------------------------------- */
  /*                ADVANCED FILTER               */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/residual-value/filter',
    },
    component: (
      <AdvancedFilter
        mode="assets-change"
        app="fixed-assets"
        hasStatus
        hasDocDate
        hasDateRange
      />
    ),
  },

  /* -------------------------------------------- */
  /*                     MAIN                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/residual-value',
    },
    component: <ResidualValueMain />,
  },

  /* -------------------------------------------- */
  /*                     FORM                     */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path: '/fixed-assets/:CompanyID/assets-change/residual-value/add',
    },
    component: <ResidualValueForm formMode="add" type="ASSETS_REGISTRATION" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/residual-value/:ResidualValueID/edit',
    },
    component: <ResidualValueForm formMode="edit" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/residual-value/:ResidualValueID/approve-reject',
    },
    component: <ResidualValueForm formMode="approve-reject" />,
  },
  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/residual-value/:ResidualValueID/resubmit',
    },
    component: <ResidualValueForm formMode="resubmit" />,
  },

  /* -------------------------------------------- */
  /*                    DETAIL                    */
  /* -------------------------------------------- */

  {
    props: {
      exact: true,
      path:
        '/fixed-assets/:CompanyID/assets-change/residual-value/:ResidualValueID/detail',
    },
    component: <ResidualValueDetail />,
  },
]

export default residualValueRoutes
